import { getAxiosInstance } from "./axiosInstance";

/**
 * List dispatched stock awaiting activation
 */
const getDealerActivationList = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/dealer/list/",
    data
  );
};

/**
 * Send Activation Command
 */
const sendDealerActivationCommand = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/dealer/activate/",
    data
  );
};

const DealerActivationService = {
    getDealerActivationList,
    sendDealerActivationCommand,
};

export default DealerActivationService;